import { useEffect, useRef, RefObject } from 'react';
import { useLocation } from 'react-router-dom';

interface UseScrollToElementOnLoadProps {
  targetId: string; 
  targetRef: RefObject<HTMLElement>; 
  loadingStates: boolean[];
  isEnabled?: boolean;
  scrollOffset?: number;
}

export const useScrollToElementOnLoad = ({
  targetId,
  targetRef,
  loadingStates,
  isEnabled = true,
  scrollOffset = 0,
}: UseScrollToElementOnLoadProps) => {
  const location = useLocation();
  const hasScrolledRef = useRef(false);

  const isAnyLoading = loadingStates?.some(loading => loading);

  const performScroll = () => {
    const element = targetRef.current;
    if (element) {
      const elementRect = element.getBoundingClientRect();
      const absoluteElementTop = elementRect.top + window.scrollY;
      const targetScrollY = absoluteElementTop - scrollOffset;

      window.scrollTo({
        top: targetScrollY,
        behavior: 'smooth',
      });
      hasScrolledRef.current = true; 
    }
  };

  useEffect(() => {
    let timeoutId: NodeJS.Timeout | undefined = undefined;

    if (!isEnabled || isAnyLoading) {
    } else {
      const params = new URLSearchParams(location.search);
      const scrollTo = params.get('scrollTo');

      if (scrollTo === targetId && !hasScrolledRef.current) {
        if (targetRef.current) {
          performScroll();
        } else {
          timeoutId = setTimeout(() => {
            performScroll();
          }, 100);
        }
      }
    }

    return () => {
      if (timeoutId !== undefined) {
        clearTimeout(timeoutId);
      }
    };
  }, [
    location.search,
    isAnyLoading,
    isEnabled,
    targetId,
    targetRef,
    scrollOffset,
    performScroll
  ]);
}; 